/**
 * OAuth PKCE utility functions for VA API integration
 */

/**
 * Generates a random string for code_verifier
 * @returns {string} A random string for PKCE
 */
export const generateCodeVerifier = () => {
  const array = new Uint8Array(56);
  window.crypto.getRandomValues(array);
  return Array.from(array, (byte) => 
    ('0' + (byte & 0xFF).toString(16)).slice(-2)
  ).join('').substring(0, 96);
};

/**
 * Creates a code challenge from a code verifier using SHA-256
 * @param {string} codeVerifier - The code verifier to hash
 * @returns {Promise<string>} Base64URL encoded code challenge
 */
export const generateCodeChallenge = async (codeVerifier) => {
  // Convert verifier to UTF-8
  const encoder = new TextEncoder();
  const data = encoder.encode(codeVerifier);
  
  // Hash with SHA-256
  const hash = await window.crypto.subtle.digest('SHA-256', data);
  
  // Convert to Base64URL encoding
  return base64URLEncode(hash);
};

/**
 * Encodes an ArrayBuffer to Base64URL format
 * @param {ArrayBuffer} buffer - The buffer to encode
 * @returns {string} Base64URL encoded string
 */
const base64URLEncode = (buffer) => {
  // Convert ArrayBuffer to Base64
  const base64 = window.btoa(
    String.fromCharCode.apply(null, new Uint8Array(buffer))
  );
  
  // Convert Base64 to Base64URL (replace + with -, / with _, remove =)
  return base64
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');
};

export const decodeLaunchContext = (launchToken) => {
  try {
    // Launch tokens are base64 encoded JSON
    const decoded = atob(launchToken);
    const context = JSON.parse(decoded);
    
    // console.log('📋 Decoded launch context:', context);
    return context;
  } catch (error) {
    console.error('❌ Failed to decode launch token:', error);
    // console.log('Launch token (first 50 chars):', launchToken?.substring(0, 50));
    
    // Fallback: treat as plain patient ID
    return {
      patientId: launchToken,
      sta3n: null,
      duz: null
    };
  }
};